<template>
  <v-menu close-on-click close-on-content-click offset-y transition="scroll-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <span class="body-1">{{ lang.flag }}</span>
      </v-btn>
    </template>

    <v-list dense nav v-if="locales">
      <v-list-item v-for="locale in locales" :key="locale.code" @click="lang = locale.code">
        <v-list-item-title
          :class="{ 'body-1': true, 'primary--text': locale.code === lang.code}"
        >{{ locale.flag.toUpperCase() }} ({{ locale.name }})</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
const allLocales  = [
  { code: 'uk', name: 'Українська', flag: 'ua', rtl: false },
  { code: 'ru', name: 'Русский', flag: 'ru', rtl: false },
  { code: 'en', name: 'English', flag: 'en', rtl: false },
  { code: 'ar', name: 'Arabian', flag: 'ar', rtl: true }
]

export default {
  name: 'LangSwitcher',
  data: () => ({
    defaultLocales: [
      { code: 'uk', name: 'Українська', flag: 'ua', rtl: false },
      { code: 'ru', name: 'Русский', flag: 'ru', rtl: false },
      { code: 'en', name: 'English', flag: 'en', rtl: false }
    ]
  }),
  created() {
    let foundLocale = this.locales.find(lang => lang.code === this.$i18n.locale)
    if (!foundLocale) {
      this.setLang(this.locales[0].code)
    }
    this.setRTL(this.$i18n.locale)
  },
  computed: {
    lang: {
      get() {
        return this.locales.find(lang => lang.code === this.$i18n.locale)
      },
      set(lang) {
        this.setRTL(lang)
        this.setLang(lang)
        window.location.reload()
      }
    },
    locales() {
      let modelLocales = this.$store.state.appRunner.model.Settings.Locales
      if (!modelLocales?.length) {
        return this.defaultLocales
      }
      // Языки из модели
      let locales = []
      for (let i = 0; i < modelLocales.length; i++) {
        let item = allLocales.find( x => x.code === modelLocales[i])
        locales.push(item)
      }

      return locales
    }
  },
  methods: {
    setRTL(lang) {
      let rtl = !!this.locales.find(x => x.code === lang)?.rtl
      this.$vuetify.rtl = rtl
    },
    async setLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('language', lang)
      document.querySelector('html').setAttribute('lang', lang)
      this.$vuetify.lang.current = lang
      
      const { status, systemLocalization, userLocalization } = await this.$store.dispatch('changeLocaleAsync', lang)
      if (!status) {
        return
      }

      let i18n = this.$i18n
      const applyLocaization = function (localization) {
        try {
          // если массив, значит приложение имеет несколько модулей с локализацией
          if (Array.isArray(localization)) {
            localization.forEach(x => i18n.mergeLocaleMessage(i18n.locale, JSON.parse(x)))
          } else {
            i18n.mergeLocaleMessage(i18n.locale, localization)
          }
        } catch (err) {
          console.error('Something wrong during apply localization: ', err)
        }
      }

      applyLocaization(systemLocalization)
      applyLocaization(userLocalization)

      // принудительно обновляем ещё раз локализацию
      this.$i18n.locale = undefined
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped>
</style>
